/* @flow */

import classNames from 'classnames';
import * as React from 'react';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';

import styles from './CameraIcon.style';

import BaseIcon from 'src/shared/ui/component/icon/BaseIcon';

import svg from './camera.svg';

type Props = {
  className?: string,
  title?: string,
};

const useStyles = createUseThemeStyles(styles);

const CameraIcon = ({ className, title }: Props): React.Node => {
  const classes = useStyles();

  return (
    <BaseIcon
      className={classNames(classes.root, className)}
      svg={svg}
      title={title}
    />
  );
};

export default React.memo<Props>(CameraIcon);
